/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../../common/constants';
import utils from '../../../../common/utils';
import { buildRubricsListPath } from './rubricsApiPaths';

/**
 * GET /rubrics?graphId= — active rubric options for the Evaluation Report search.
 */
export default class EvalGraphRubricsService extends BaseService {
  constructor() {
    super(constants.GET_EVAL_GRAPH_RUBRICS, 'EvalGraphRubricsStatus');
  }

  async handleEvent(eventName, event) {
    const { graphId, tenantId } = event;
    const headers = utils.buildHeadersWithTenantId({ tenantId });
    const url = buildRubricsListPath({ graphId });
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').get(url, { headers: enhancedHeaders });
    }
    return this.getClient('aiadmin').get(url, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data?.success) {
      const body = data?.data ?? data;
      const evaluations = Array.isArray(body?.evaluations) ? body.evaluations : [];
      Framework.getEventManager().publish(constants.SET_EVAL_GRAPH_RUBRICS, { evaluations });
      return;
    }
    Framework.getEventManager().publish(constants.SET_EVAL_GRAPH_RUBRICS, { evaluations: [], error: true });
  }

  handleError() {
    Framework.getEventManager().publish(constants.SET_EVAL_GRAPH_RUBRICS, { evaluations: [], error: true });
  }
}
